import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, Observer, Subject, of } from 'rxjs';

import { ProductCard } from '@shared/models/product-card.model';
import { Product, ProductsList } from '@shared/models/products.model';

@Injectable({
  providedIn: 'root'
})
export class ProductsBaseService {
  protected isPrimary: boolean;
  protected selectedProductId: string;

  public cleanCache = false;
  public productCards$ = new BehaviorSubject<ProductCard[]>([]);
  public products: Product[];
  public productsList$ = new BehaviorSubject<ProductsList[]>([]);
  public productsLoaded$ = new BehaviorSubject<boolean>(false);
  public refreshProducts$ = new BehaviorSubject(true);
  public resetCacheTimer$: Subject<void> = new Subject<void>();
  public timer = undefined;

  /**
   * Очистка продуктов
   */
  public clearProducts() {
    console.log('clear products');
    this.products = null;
    this.productCards$.next([]);
    this.productsList$.next([]);
    this.productsLoaded$.next(false);
    this.selectedProductId = null;
  }

  /**
   * Получение продукта по ID
   */
  public getProduct(id: string): Observable<Product | undefined | any> {
    return Observable.create((observer: Observer<Product>) => {
      if (this.products && this.products.length) {
        observer.next(this.findProductById(this.products, id));

        return observer.complete();
      }
      this.getProducts().subscribe((_products: Product[]) => {
        observer.next(this.findProductById(this.products, id));

        return observer.complete();
      });
    });
  }

  /**
   * Получение продуктов (заглушка, переопределяется в ProductsService)
   */
  public getProducts(refresh = false): Observable<Product[]> {
    return of([]);
  }

  /**
   * Получение продуктов по типу
   */
  public getProductsByType(type: string) {
    return this.products.filter((item: Product) => item.productType === type);
  }

  /**
   * Получение выбранного продукта
   */
  public getSelectedProduct(): { id: string; isPrimary: boolean } {
    const id = this.selectedProductId;
    const isPrimary = this.isPrimary;

    return { id, isPrimary };
  }

  /**
   * Сброс таймера кеша продуктов
   */
  public resetProductsCacheTimer() {
    this.cleanCache = true;
    this.resetCacheTimer$.next(null);
    this.startProductsCacheTimer();
  }

  /**
   * Запоминаем выбранный продукт для "платеж или перевод"
   */
  public selectProduct(id: string, primary = true) {
    this.selectedProductId = id;
    this.isPrimary = primary;
  }

  /**
   * Реализация таймера кеша продуктов
   */
  public startProductsCacheTimer() {
    // Реализация метода
  }

  /**
   * Поиск продукта по идентификатору
   */
  public findProductById(products: Product[], id: string): Product | undefined {
    return products.find((item) => item.id === id);
  }
}
